import { createContext, useContext, useState } from 'react';

const useIpQueryProviderContext = () => {
  const [queryIp, setQueryIp] = useState<string>('');
  return {
    queryIp,
    setQueryIp,
  };
};

const IpQueryProviderContext = createContext(
  {} as ReturnType<typeof useIpQueryProviderContext>
);

export const useIpQueryContext = () => useContext(IpQueryProviderContext);

export const IpQueryContextProvider = ({ children }) => {
  return (
    <IpQueryProviderContext.Provider value={useIpQueryProviderContext()}>
      {children}
    </IpQueryProviderContext.Provider>
  );
};
